<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <div class="logo" (click)="navigateHome()"><img src="../../../../assets/images/LANDY_Logo-Horizontal.png"
        alt="Landy Logo" height="40"></div>
    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
        <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
      </nb-select> -->
  </div>

</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="control-item">
      <!-- <mat-form-field>
        <input matInput type="text" placeholder="Search">
        <button mat-button matSuffix mat-icon-button>
          <i class="ion-search icon-display"></i>
        </button>
      </mat-form-field> -->
    </nb-action>
    <nb-action class="control-item"><i style="cursor:pointer;font-size:1.2rem;color: #8f9bb3;" data-toggle="popover"
        title="Finance Calculator" class="fa fa-calculator" (click)="financeCalculatorModal()"></i></nb-action>
    <nb-action class="control-item">
      <!-- <i style="cursor:pointer;font-size:1.2rem;color: #8f9bb3;" data-toggle="popover"
        title="State-wise Rate Edition" (click)="openStateWiseRateEdition()"><img src="../../../../assets\images\usa-color-img.png" height="50"  /></i> -->
      <i class="fas fa-flag-usa" (click)="openStateWiseRateEdition()" style="cursor:pointer;font-size:1.2rem;color: #8f9bb3;" data-toggle="popover"  title="State-wise Rate Edition"></i>
      </nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    <nb-action class="control-item"><span class="user-action"
        style="text-transform: uppercase;text-decoration: underline;">{{roleName}}</span></nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user [nbContextMenu]="userMenu" [name]="name">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>


